export function isIOSWebKitEnvironment(navigatorLike = {}) {
  const userAgent = String(navigatorLike.userAgent || "");
  const platform = String(navigatorLike.platform || "");
  const maxTouchPoints = Number(navigatorLike.maxTouchPoints || 0);

  return /iPad|iPhone|iPod/i.test(userAgent)
    || (platform === "MacIntel" && maxTouchPoints > 1);
}

export function getImageProcessingProfile(navigatorLike = {}) {
  const lowMemoryMode = isIOSWebKitEnvironment(navigatorLike);
  return {
    lowMemoryMode,
    maxDimension: lowMemoryMode ? 1280 : 2048,
    useBiRefNet: !lowMemoryMode,
    useSecondaryVisionModels: !lowMemoryMode,
  };
}
